import { isAnyEstimuloProduct } from 'utils/product-utils';

export type BrandGender = 'feminino' | 'masculino';

export type ProductBrand = {
    branchName: string;
    branchShortName: string;
    gender: BrandGender;
};

export const DEFAULT_BRAND: ProductBrand = {
    branchName: 'BizCapital',
    branchShortName: 'Biz',
    gender: 'feminino',
};

export const ESTIMULO_BRAND: ProductBrand = {
    branchName: 'Estímulo',
    branchShortName: 'Estímulo',
    gender: 'masculino',
};

export const getProductBrand = (bizId?: string | null): ProductBrand =>
    isAnyEstimuloProduct(bizId) ? ESTIMULO_BRAND : DEFAULT_BRAND;

export const brandArticle = (brand: ProductBrand) => {
    const feminine = brand.gender === 'feminino';

    return {
        o_a:       feminine ? 'a'    : 'o',
        da_do:     feminine ? 'da'   : 'do',
        na_no:     feminine ? 'na'   : 'no',
        pela_pelo: feminine ? 'pela' : 'pelo',
        à_ao:      feminine ? 'à'    : 'ao',
    };
};
